
import {
  defineComponent, inject, reactive, watch, Ref, provide,
  computed,
} from 'vue';
import { Modal } from 'ant-design-vue';
import Icone from '@/core/components/Icone.vue';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import { useModalBase } from '@/core/composables/ModalBase';
import { useRequisicaoAutorizacaoBase } from '@/composables/MeuSistema/RequisicaoAutorizacaoBase';
import RequisicaoModal from '@/core/components/Modal/RequisicaoModal.vue';
import Card from '@/core/components/Tela/Card.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import SelecionarData from '@/core/components/Tela/SelecionarData.vue';
import SelecionarFormaPagamento from '@/components/Cadastros/Financeiro/SelecionarFormaPagamento.vue';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import { ETipoFrete } from '@/models/Enumeradores/Compartilhados/ETipoFrete';
import { EStatusRetornoRequisicao, IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import SelecionarColaborador from '@/components/Cadastros/Pessoas/Colaboradores/SelecionarColaborador.vue';
import SelecionarPessoa from '@/components/Cadastros/Pessoas/SelecionarPessoa.vue';
import UtilitarioDispositivo from '@/core/utilitarios/UtilitarioDispositivo';
import { IEtapaProcessoVendas, IProcessoVendas } from '@/models/Entidades/Cadastros/Vendas/IProcessoVendas';
import ServicoVendas from '@/servicos/Vendas/ServicoVendas';
import SelecionarMarcadorNotaFiscal from '@/components/Fiscal/NotasFiscais/SelecionarMarcadorNotaFiscal.vue';
import VendaItens from '@/components/Vendas/Vendas/ModalVenda/VendaItens.vue';
import SelecionarStatusVenda from '@/components/Vendas/SelecionarStatusVenda.vue';
import EditorHtml from '@/core/components/Tela/EditorHtml.vue';
import { ETipoRelacaoPessoa } from '@/models/Enumeradores/Cadastros/Pessoas/ETipoRelacaoPessoa';
import {
  IVenda, IVendaItem, IVendaNotaFiscalServico,
} from '@/models/Entidades/Vendas/IVenda';
import {
  INotaFiscal, INotaFiscalAnexo, INotaFiscalDestinatario, INotaFiscalDetalhePagamento, INotaFiscalEmitente, INotaFiscalImpostoTotal, INotaFiscalIncidenciaCalculo, INotaFiscalItemImpostoIbsCbs, INotaFiscalItemImpostoIbsCbsCreditoAjuste, INotaFiscalItemImpostoIbsCbsMonofasico, INotaFiscalMarcador, INotaFiscalTransporte, INotaFiscalTransporteVolume,
} from '@/models/Entidades/Fiscal/INotaFiscal';
import { ISalvamentoAutomatico } from '@/models/Entidades/MeuSistema/ISalvamentoAutomatico';
import storeSistema from '@/store/storeSistema';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import ServicoNotaFiscal from '@/servicos/Fiscal/ServicoNotaFiscal';
import { ETipoValorMovimentacao } from '@/models/Enumeradores/ETipoValorMovimentacao';
import ServicoCalculosComerciais from '@/servicos/ServicoCalculosComerciais';
import { EOrigemValorItem } from '@/models/Enumeradores/EOrigemValorItem';
import { ETipoMovimentoComercial } from '@/core/models/Enumeradores/ETipoMovimentoComercial';
import ServicoFormaPagamento from '@/servicos/Cadastros/Financeiro/ServicoFormaPagamento';
import { IFormaPagamento } from '@/models/Entidades/Cadastros/Financeiro/IFormaPagamento';
import RequisitarAutorizacaoModal from '@/components/MeuSistema/ControleAutorizacoes/RequisitarAutorizacaoModal.vue';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import NotaFiscalImpostos from '@/components/Fiscal/NotasFiscais/NotaFiscalImpostos.vue';
import NotaFiscalFrete from '@/components/Fiscal/NotasFiscais/NotaFiscalFrete.vue';
import NotaFiscalAnexos from '@/components/Fiscal/NotasFiscais/NotaFiscalAnexos.vue';
import NotaFiscalHistorico from '@/components/Fiscal/NotasFiscais/NotaFiscalHistorico.vue';
import { ETipoOperacao } from '@/models/Enumeradores/Fiscal/ETipoOperacao';
import { ETipoEmissao } from '@/models/Enumeradores/Fiscal/ETipoEmissao';
import { IDTONotaFiscalRegistroAtividade } from '@/models/DTO/Fiscal/NotasFiscais/IDTONotaFiscalRegistroAtividade';
import { useFocusBase } from '@/core/composables/FocusBase';
import ServicoPessoa from '@/servicos/Cadastros/Pessoas/ServicoPessoa';
import { IDTOPessoaMovimento } from '@/models/DTO/Cadastros/Pessoas/IDTOPessoaMovimento';
import VendaDetalhesPagamento from '@/components/Vendas/Vendas/ModalVenda/PagamentoVenda/VendaDetalhesPagamento.vue';
import NotaFiscalDescontosAcrescimos from '@/components/Fiscal/NotasFiscais/NotaFiscalDescontosAcrescimos.vue';
import BarraProgresso from '@/core/components/Tela/BarraProgresso.vue';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import { IDTODadosEmpresa } from '@/models/DTO/MeuSistema/Empresas/IDTODadosEmpresa';
import UtilitarioMatematico from '@/core/utilitarios/UtilitarioMatematico';
import NotaFiscalServicoItens from '@/components/Fiscal/NotasFiscaisServicos/NotaFiscalServicoItens.vue';
import { INotaFiscalServicoItem } from '@/models/Entidades/Fiscal/INotaFiscalServico';
import ServicoEmpresa from '@/servicos/MeuSistema/ServicoEmpresa';
import ServicoServico from '@/servicos/Cadastros/PrestacaoServicos/ServicoServico';
import { ETipoPessoa } from '@/models/Enumeradores/Compartilhados/ETipoPessoa';
import ServicoUtilitario from '@/servicos/MeuSistema/ServicoUtilitario';
import { ETipoBloqueioCliente } from '@/models/Enumeradores/Cadastros/Pessoas/ETipoBloqueioCliente';
import ServicoCliente from '@/servicos/Cadastros/Pessoas/ServicoCliente';
import SelecionarTipoOperacao from '@/components/Cadastros/SelecionarTipoOperacao.vue';
import { ITipoOperacao } from '@/models/Entidades/Cadastros/ITipoOperacao';
import ServicoTipoOperacao from '@/servicos/Cadastros/ServicoTipoOperacao';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import VendaComissao from '@/components/Vendas/Vendas/ModalVenda/VendaComissao.vue';
import VendaOrdensProducaoVinculadasTab from '@/components/Vendas/Vendas/ModalVenda/VendaOrdensProducaoVinculadasTab.vue';
import { EStatusNotaFiscal } from '@/models/Enumeradores/Compartilhados/EStatusNotaFiscal';
import { EStatusVenda } from '@/models/Enumeradores/Vendas/EStatusVenda';

export default defineComponent({
  name: 'VendaModal',
  props: {
    visivel: {
      type: Boolean,
    },
    editavel: {
      type: Boolean,
      default: true,
    },
    codigoVenda: {
      type: Number,
      required: true,
    },
    duplicarVenda: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RequisicaoModal,
    Card,
    PreviewPdf,
    Icone,
    BarraProgresso,
    EditorHtml,
    SelecionarData,
    SelecionarColaborador,
    SelecionarPessoa,
    SelecionarFormaPagamento,
    SelecionarMarcadorNotaFiscal,
    VendaItens,
    SelecionarStatusVenda,
    RequisitarAutorizacaoModal,
    NotaFiscalImpostos,
    NotaFiscalFrete,
    NotaFiscalDescontosAcrescimos,
    VendaDetalhesPagamento,
    NotaFiscalAnexos,
    NotaFiscalHistorico,
    NotaFiscalServicoItens,
    SelecionarTipoOperacao,
    VendaComissao,
    VendaOrdensProducaoVinculadasTab,
  },
  emits: ['update:visivel', 'confirmacao', 'update:duplicar'],
  setup(props, { emit }) {
    const servicoVendas = new ServicoVendas();
    const servicoCalculosComerciais = new ServicoCalculosComerciais();
    const servicoFormaPagamento = new ServicoFormaPagamento();
    const servicoEmpresas = new ServicoEmpresa();
    const servicoServico = new ServicoServico();
    const servicoUtilitario = new ServicoUtilitario();
    servicoEmpresas.requisicaoSistema();
    servicoFormaPagamento.requisicaoSistema();
    const servicoNotaFiscal = new ServicoNotaFiscal();
    servicoNotaFiscal.requisicaoSistema();
    const servicoSistema = new ServicoSistema();
    const servicoPessoa = new ServicoPessoa();
    servicoPessoa.requisicaoSistema();
    const servicoCliente = new ServicoCliente();
    const servicoTipoOperacao = new ServicoTipoOperacao();
    servicoTipoOperacao.requisicaoSistema();

    const {
      telaBase,
      apresentarMensagemSucesso, apresentarMensagemAlerta, preencherEmpresasDisponiveis, filtrarPermissaoDadosUsuarioMultiEmpresas, apresentarMensagemErro,
    } = useTelaBase();
    const {
      modalBase, apresentarRetornoRequisicao, apresentarBarraProgresso, ocultarBarraProgresso,
    } = useModalBase(props, emit);

    const {
      focusBase, focusElemento, proximoElemento, elementoAnterior,
    } = useFocusBase();

    focusBase.classElementos = 'ss-venda-dados-principais';

    const { requisicaoAutorizacaoBase } = useRequisicaoAutorizacaoBase();
    const dadosEmpresa = inject('VENDAS_EMPRESA') as Ref<IDTODadosEmpresa>;
    const etapa = inject('VENDAS_ETAPA_LANCAMENTO') as Ref<IEtapaProcessoVendas>;
    const processoVendas = inject('VENDAS_PROCESSO_VENDAS') as Ref<IProcessoVendas>;
    const permissaoServico = inject('VENDAS_PERMISSAO_SERVICO') as Ref<boolean>;

    telaBase.identificadorRecurso = 'VENDAS';
    let debounceCacheRegistro = 0;
    let debounceAtualizacaoTotalizadores = 0;
    let debounceRenderizar = 0;
    const state = reactive({
      venda: {} as IVenda,
      dadosPessoaMovimento: {} as IDTOPessoaMovimento,
      ufEmpresa: '',
      marcadores: [] as string[],
      registrosAtividade: [] as IDTONotaFiscalRegistroAtividade[],
      incidenciasCalculo: [] as INotaFiscalIncidenciaCalculo[],
      tipoOperacao: {} as ITipoOperacao,
      servicos: [] as INotaFiscalServicoItem[],
      cacheRegistro: {} as ISalvamentoAutomatico,
      tabelasPrecosDisponiveis: [] as number[],
      permitirNfe: true,
      permitirNfce: true,
      regimeTributario: 0,
      regimeTributarioEspecial: 0,
      totalCaixaLancado: 0,
      totalCarteiraLancado: 0,
      totalOutrosLancado: 0,
      telaMobile: false,
      editavel: false,
      cacheDisponivel: false,
      calculandoValores: false,
      chaveItens: 0,
      exibirAlteracaoEtapa: false,
      carregando: false,
      carregandoItens: false,
      adicionarPrimeiroItem: false,
      buscarDadosFiscaisRecalcular: false,
      criacaoVendaAutomatico: false,
      incluindoCabecalhoVenda: false,
      arquivosPdf: [] as IArquivoPdf[],
      valorTotalImpostos: 0,
      statusBloqueioCliente: false,
      liberacaoBloqueioCliente: false,
      tipoInfoBloqueioCliente: 'info',
      editarComissao: false,
      abaAtiva: '1',
      tipoFreteManual: false,
      permitirAlterarTipoOperacao: false,
    });

    const possuiOrdensProducaoVinculadas = computed(() => state.venda.itens.some((item) => item.ordensProducaoVinculadas && item.ordensProducaoVinculadas.length > 0));
    const computedDuplicarVenda = computed({
      get: () => (props.duplicarVenda),
      set: (val: boolean) => {
        emit('update:duplicar', val);
      },
    });
    provide('VENDA_INCIDENCIA_CALCULO', state.incidenciasCalculo);

    async function limparTela() {
      state.abaAtiva = '1';
      state.criacaoVendaAutomatico = false;
      state.incluindoCabecalhoVenda = false;
      state.adicionarPrimeiroItem = false;
      state.buscarDadosFiscaisRecalcular = false;
      state.editarComissao = false;
      state.incidenciasCalculo = servicoVendas.obterIncidenciasNotaFiscalVendaPadrao();
      state.totalCaixaLancado = 0;
      state.totalCarteiraLancado = 0;
      state.totalOutrosLancado = 0;
      state.tipoOperacao = {} as ITipoOperacao;
      state.tipoOperacao.codigoFormaPagamento = 0;
      state.tipoOperacao.codigoCenarioFiscal = 0;
      state.tipoOperacao.movimentarEstoque = false;
      state.venda = {} as IVenda;
      state.venda.codigo = 0;
      state.venda.codigoEmpresa = dadosEmpresa.value.codigoEmpresa;
      state.venda.codigoProcessoVendas = etapa.value.codigoProcessoVendas;
      state.venda.codigoEtapaProcessoVendas = etapa.value.codigo;
      state.venda.dataVenda = UtilitarioData.obterDataAtual();
      state.venda.codigoFormaPagamento = 0;
      state.venda.codigoVendedor = 0;
      state.venda.codigoCliente = 0;
      state.venda.codigoContatoCliente = 0;
      state.venda.dataCriacao = UtilitarioData.obterDataAtual();
      state.venda.itens = [] as IVendaItem[];
      state.venda.notaFiscal = {} as INotaFiscal;
      state.venda.notaFiscal.numeroNotaFiscal = 0;
      state.venda.notaFiscal.naturezaOperacao = 'NATUREZA';
      state.venda.notaFiscal.codigoEmpresa = state.venda.codigoEmpresa;
      state.venda.notaFiscal.destinatario = {} as INotaFiscalDestinatario;
      state.venda.notaFiscal.destinatario.codigoPessoa = 0;
      state.venda.notaFiscal.pessoaIdentificada = true;

      state.venda.notaFiscal.tipoOperacao = ETipoOperacao.Saida;
      state.venda.notaFiscal.tipoFrete = ETipoFrete.SemOcorrenciaTransporte;
      state.venda.notaFiscal.tipoEmissao = ETipoEmissao.EmissaoPropria;
      state.venda.notaFiscal.serie = '0';
      state.venda.notaFiscal.modelo = '55';
      state.venda.notaFiscal.dataEmissao = UtilitarioData.obterDataAtual();
      state.venda.notaFiscal.dataEntradaSaida = UtilitarioData.obterDataAtual();
      state.venda.notaFiscal.emitente = {} as INotaFiscalEmitente;
      state.venda.notaFiscal.emitente.codigoPessoa = 0;
      state.venda.notaFiscal.totalImpostos = {} as INotaFiscalImpostoTotal;
      state.venda.notaFiscal.transporte = {} as INotaFiscalTransporte;
      state.venda.notaFiscal.transporte.codigoTransportadora = 0;
      state.venda.notaFiscal.transporte.volumes = [] as INotaFiscalTransporteVolume[];
      state.venda.notaFiscal.totalDesconto = 0;
      state.venda.notaFiscal.totalFrete = 0;
      state.venda.notaFiscal.totalNotaFiscal = 0;
      state.venda.notaFiscal.totalOutrasDespesas = 0;
      state.venda.notaFiscal.totalProdutos = 0;
      state.venda.notaFiscal.totalSeguro = 0;
      state.venda.notaFiscal.totalImpostos.valorAproximadoTributosTotal = 0;
      state.venda.notaFiscal.anexos = [] as INotaFiscalAnexo[];
      state.venda.notaFiscal.detalhesPagamento = [] as INotaFiscalDetalhePagamento[];
      state.venda.formaPagamento = {} as IFormaPagamento;
      state.dadosPessoaMovimento = {} as IDTOPessoaMovimento;
      state.dadosPessoaMovimento.cpfCnpj = '';
      state.venda.atualizarValores = false;
      state.servicos = [] as INotaFiscalServicoItem[];
      state.venda.totalServicos = 0;
      state.marcadores = [] as string[];
      state.registrosAtividade = [] as IDTONotaFiscalRegistroAtividade[];
      state.venda.status = etapa.value.statusVenda;
      state.editavel = props.editavel;
      state.cacheDisponivel = false;
      state.cacheRegistro = {} as ISalvamentoAutomatico;
      state.cacheRegistro.codigo = 0;
      state.exibirAlteracaoEtapa = false;
      state.carregando = false;
      state.carregandoItens = false;
      state.statusBloqueioCliente = false;
      state.tipoFreteManual = false;
      state.valorTotalImpostos = 0;
    }

    function obterIdentificadorCache() {
      return `${telaBase.identificadorRecurso}_${etapa.value.codigoProcessoVendas}_${etapa.value.codigo}_${state.venda.codigo}`;
    }

    async function salvarCacheRegistro() {
      clearTimeout(debounceCacheRegistro);
      debounceCacheRegistro = setTimeout(async () => {
        state.cacheRegistro.data = UtilitarioData.obterDataAtual();
        state.cacheRegistro.codigoEmpresa = state.venda.codigoEmpresa;
        state.cacheRegistro.codigoUsuario = storeSistema.getters.codigoUsuarioAutenticado();
        state.cacheRegistro.identificador = obterIdentificadorCache();
        state.cacheRegistro.dados = JSON.stringify(state.venda);
        await servicoSistema.salvamentoAutomaticoLocalStorage(`${obterIdentificadorCache()}_${state.cacheRegistro.codigoUsuario}`, state.cacheRegistro);
        const retornoSalvamento = await servicoSistema.salvamentoAutomaticoApi(state.cacheRegistro);
        if (retornoSalvamento.status === EStatusRetornoRequisicao.Sucesso) {
          state.cacheRegistro.codigo = retornoSalvamento.codigoRegistro;
        }
      }, 600);
    }

    async function verificarPermissaoNFeNFce() {
      if (state.dadosPessoaMovimento.codigoEstado === 0) {
        state.permitirNfce = true;
        state.permitirNfe = false;
        state.venda.notaFiscal.modelo = '65';
        return;
      }

      if (state.dadosPessoaMovimento.uf !== dadosEmpresa.value.uf) {
        state.permitirNfe = true;
        state.permitirNfce = false;
        state.venda.notaFiscal.modelo = '55';
        return;
      }

      if (state.dadosPessoaMovimento.tipoPessoa === ETipoPessoa.Fisica) {
        const cpfsInvalidos = ['00000000000', '11111111111', '22222222222', '33333333333', '44444444444', '55555555555', '66666666666', '77777777777', '88888888888', '99999999999'];
        if (cpfsInvalidos.includes(state.dadosPessoaMovimento.cpfCnpj)) {
          state.permitirNfe = false;
          state.permitirNfce = true;
          state.venda.notaFiscal.modelo = '65';
          return;
        }

        const cpfValido = await servicoUtilitario.validarCpfCnpj(state.dadosPessoaMovimento.cpfCnpj);
        if (!cpfValido.sucesso) {
          state.permitirNfe = false;
          state.permitirNfce = true;
          state.venda.notaFiscal.modelo = '65';
          return;
        }
      }

      state.permitirNfe = true;
      state.permitirNfce = true;
      if (!UtilitarioGeral.validaCodigo(props.codigoVenda)) state.venda.notaFiscal.modelo = '55';
    }

    async function calcularComissoes(forcarRecalculo = false) {
      if (!state.editavel && !forcarRecalculo) return;
      if (!UtilitarioGeral.validaCodigo(state.venda.codigoVendedor) && !UtilitarioGeral.validaCodigo(state.venda.codigoTipoOperacao)) return;
      if (state.venda.notaFiscal.totalProdutos === 0) return;

      let gerarComissao = state.tipoOperacao.gerarComissao;
      if (!gerarComissao) return;
      if (!forcarRecalculo) {
        state.venda.comissoes.forEach((c) => {
          if (UtilitarioGeral.validaCodigo(c.codigoColaborador)) {
            gerarComissao = false;
          }
        });
      }
      if (gerarComissao) {
        const comissoes = await servicoVendas.calcularComissoes(state.venda);
        if (state.venda.comissoes.length === comissoes.length || state.venda.comissoes.length === 0 || forcarRecalculo) {
          state.venda.comissoes = comissoes;
        }
      }
    }

    async function atualizarValoresTotais() {
      if (state.venda.itens.length > 0) {
        console.log('atualizarValoresTotais inicio', state.venda.itens[0].itemNotaFiscal.impostos.st.margemValorAdicionado, state.venda.itens[0].itemNotaFiscal.impostos.st.cest);
      }

      if (!telaBase.carregando && !state.carregandoItens) {
        clearTimeout(debounceAtualizacaoTotalizadores);
        debounceAtualizacaoTotalizadores = setTimeout(async () => {
          state.venda.notaFiscal.totalProdutos = 0;
          state.venda.notaFiscal.totalDesconto = 0;
          state.venda.notaFiscal.totalImpostos.baseCalculoIcmsTotal = 0;
          state.venda.notaFiscal.totalImpostos.valorIcmsTotal = 0;
          state.venda.notaFiscal.totalImpostos.baseCalculoIcmsSubstituicaoTotal = 0;
          state.venda.notaFiscal.totalImpostos.valorIcmsSubstituicaoTotal = 0;
          state.venda.notaFiscal.totalImpostos.baseCalculoIpiTotal = 0;
          state.venda.notaFiscal.totalImpostos.valorIpiTotal = 0;
          state.venda.notaFiscal.totalImpostos.baseCalculoPisTotal = 0;
          state.venda.notaFiscal.totalImpostos.valorPisTotal = 0;
          state.venda.notaFiscal.totalImpostos.baseCalculoCofinsTotal = 0;
          state.venda.notaFiscal.totalImpostos.valorCofinsTotal = 0;
          state.venda.notaFiscal.totalImpostos.valorAproximadoTributosTotal = 0;

          state.venda.notaFiscal.totalImpostos.valorIbsUfTotal = 0;
          state.venda.notaFiscal.totalImpostos.valorIbsMunicipioTotal = 0;
          state.venda.notaFiscal.totalImpostos.valorCbsTotal = 0;
          state.venda.notaFiscal.totalImpostos.valorIbsTotal = 0;
          state.venda.notaFiscal.totalImpostos.valorBaseCalculoCbsTotal = 0;
          state.venda.notaFiscal.totalImpostos.valorBaseCalculoIbsTotal = 0;
          state.venda.notaFiscal.totalImpostos.valorBaseCalculoIbsCbsTotal = 0;

          state.valorTotalImpostos = 0;
          for (let index = 0; index < state.venda.itens.length; index += 1) {
            if (UtilitarioGeral.validaCodigo(state.venda.itens[index].itemNotaFiscal.codigoProdutoDefinicao)) {
              state.venda.itens[index].itemNotaFiscal.valorTotal = servicoCalculosComerciais.calculaValorTotal(state.venda.itens[index].itemNotaFiscal.quantidade, state.venda.itens[index].itemNotaFiscal.precoUnitario, state.venda.itens[index].itemNotaFiscal.valorDesconto, 0);
              if (state.venda.itens[index].itemNotaFiscal.compoeTotal) {
                state.venda.notaFiscal.totalProdutos += state.venda.itens[index].itemNotaFiscal.quantidade * state.venda.itens[index].itemNotaFiscal.precoUnitario;
                state.venda.notaFiscal.totalDesconto += state.venda.itens[index].itemNotaFiscal.valorDesconto;
              }
            }
          }

          state.venda.notaFiscal.totalNotaFiscal = state.venda.notaFiscal.totalProdutos;
          for (let index = 0; index < state.venda.itens.length; index += 1) {
            if (UtilitarioGeral.validaCodigo(state.venda.itens[index].itemNotaFiscal.codigoProdutoDefinicao)) {
              const subTotalProduto = servicoCalculosComerciais.formatarValor2CasasDecimais((state.venda.itens[index].itemNotaFiscal.quantidade * state.venda.itens[index].itemNotaFiscal.precoUnitario));
              if (parseFloat((subTotalProduto).toFixed(2)) < parseFloat(((state.venda.itens[index].itemNotaFiscal.valorDesconto)).toFixed(2))) {
                state.venda.itens[index].itemNotaFiscal.valorDesconto = 0;
              }

              if (state.venda.itens[index].itemNotaFiscal.origemFrete === EOrigemValorItem.Rateio) {
                if (state.venda.notaFiscal.totalFrete > 0) {
                  state.venda.itens[index].itemNotaFiscal.valorFrete = servicoCalculosComerciais.calculaValorRateio(subTotalProduto, state.venda.notaFiscal.totalProdutos, state.venda.notaFiscal.totalFrete);
                } else {
                  state.venda.itens[index].itemNotaFiscal.valorFrete = 0;
                }
              }

              if (state.venda.itens[index].itemNotaFiscal.origemOutrasDespesas === EOrigemValorItem.Rateio) {
                if (state.venda.notaFiscal.totalOutrasDespesas > 0) {
                  state.venda.itens[index].itemNotaFiscal.outrasDespesas = servicoCalculosComerciais.calculaValorRateio(subTotalProduto, state.venda.notaFiscal.totalProdutos, state.venda.notaFiscal.totalOutrasDespesas);
                } else {
                  state.venda.itens[index].itemNotaFiscal.outrasDespesas = 0;
                }
              }

              if (state.venda.itens[index].itemNotaFiscal.origemSeguro === EOrigemValorItem.Rateio) {
                if (state.venda.notaFiscal.totalSeguro > 0) {
                  state.venda.itens[index].itemNotaFiscal.valorSeguro = servicoCalculosComerciais.calculaValorRateio(subTotalProduto, state.venda.notaFiscal.totalProdutos, state.venda.notaFiscal.totalSeguro);
                } else {
                  state.venda.itens[index].itemNotaFiscal.valorSeguro = 0;
                }
              }
              state.venda.itens[index].itemNotaFiscal.impostos.icms.aliquotaSimplesNacional = dadosEmpresa.value.aliquotaSimplesNacional;
              const retornoCalculoTributacoes = await servicoCalculosComerciais.calcularTributacoes(state.venda.itens[index].itemNotaFiscal, state.incidenciasCalculo, dadosEmpresa.value.uf, dadosEmpresa.value.codigoMunicipioIBGE);
              if (UtilitarioGeral.objetoValido(retornoCalculoTributacoes)) {
                state.venda.itens[index].itemNotaFiscal.impostos.icms.baseCalculoIcms = retornoCalculoTributacoes.icms.baseCalculoIcms;
                state.venda.itens[index].itemNotaFiscal.impostos.icms.valorIcms = retornoCalculoTributacoes.icms.valorIcms;
                state.venda.itens[index].itemNotaFiscal.impostos.icms.valorSimplesNacional = retornoCalculoTributacoes.icms.valorSimplesNacional;

                state.venda.notaFiscal.totalImpostos.baseCalculoIcmsTotal += state.venda.itens[index].itemNotaFiscal.impostos.icms.baseCalculoIcms;
                state.venda.notaFiscal.totalImpostos.valorIcmsTotal += state.venda.itens[index].itemNotaFiscal.impostos.icms.valorIcms;

                state.venda.itens[index].itemNotaFiscal.impostos.st.baseCalculoSubstituicaoTributaria = retornoCalculoTributacoes.icms.baseCalculoSubstituicaoTributaria;
                state.venda.itens[index].itemNotaFiscal.impostos.st.valorSubstituicaoTributaria = retornoCalculoTributacoes.icms.valorSubstituicaoTributaria;

                state.venda.notaFiscal.totalImpostos.baseCalculoIcmsSubstituicaoTotal += state.venda.itens[index].itemNotaFiscal.impostos.st.baseCalculoSubstituicaoTributaria;
                state.venda.notaFiscal.totalImpostos.valorIcmsSubstituicaoTotal += state.venda.itens[index].itemNotaFiscal.impostos.st.valorSubstituicaoTributaria;

                state.venda.itens[index].itemNotaFiscal.impostos.ipi.baseCalculoIpi = retornoCalculoTributacoes.ipi.baseCalculo;
                state.venda.itens[index].itemNotaFiscal.impostos.ipi.valorIpi = retornoCalculoTributacoes.ipi.valor;

                state.venda.notaFiscal.totalImpostos.baseCalculoIpiTotal += state.venda.itens[index].itemNotaFiscal.impostos.ipi.baseCalculoIpi;
                state.venda.notaFiscal.totalImpostos.valorIpiTotal += state.venda.itens[index].itemNotaFiscal.impostos.ipi.valorIpi;

                state.venda.itens[index].itemNotaFiscal.impostos.pis.baseCalculoPis = retornoCalculoTributacoes.pis.baseCalculo;
                state.venda.itens[index].itemNotaFiscal.impostos.pis.valorPis = retornoCalculoTributacoes.pis.valor;

                state.venda.notaFiscal.totalImpostos.baseCalculoPisTotal += state.venda.itens[index].itemNotaFiscal.impostos.pis.baseCalculoPis;
                state.venda.notaFiscal.totalImpostos.valorPisTotal += state.venda.itens[index].itemNotaFiscal.impostos.pis.valorPis;

                state.venda.itens[index].itemNotaFiscal.impostos.cofins.baseCalculoCofins = retornoCalculoTributacoes.cofins.baseCalculo;
                state.venda.itens[index].itemNotaFiscal.impostos.cofins.valorCofins = retornoCalculoTributacoes.cofins.valor;

                state.venda.notaFiscal.totalImpostos.baseCalculoCofinsTotal += state.venda.itens[index].itemNotaFiscal.impostos.cofins.baseCalculoCofins;
                state.venda.notaFiscal.totalImpostos.valorCofinsTotal += state.venda.itens[index].itemNotaFiscal.impostos.cofins.valorCofins;
                const dtoIbsCbs = retornoCalculoTributacoes.ibsCbs;
                if (dtoIbsCbs) {
                  if (!state.venda.itens[index].itemNotaFiscal.impostos.ibsCbs) {
                    state.venda.itens[index].itemNotaFiscal.impostos.ibsCbs = {} as INotaFiscalItemImpostoIbsCbs;
                  }
                  const impostoItemIbsCbs = state.venda.itens[index].itemNotaFiscal.impostos.ibsCbs;

                  impostoItemIbsCbs.codigoSituacaoTributaria = dtoIbsCbs.codigoSituacaoTributaria;
                  impostoItemIbsCbs.codigoClassificacaoTributaria = dtoIbsCbs.codigoClassificacaoTributaria;
                  impostoItemIbsCbs.indicadorDoacao = dtoIbsCbs.indicadorDoacao;
                  impostoItemIbsCbs.valorBaseCalculoIbsCbs = dtoIbsCbs.valorBaseCalculoIbsCbs;
                  impostoItemIbsCbs.aliquotaIbsUf = dtoIbsCbs.aliquotaIbsUf;
                  impostoItemIbsCbs.percentualReducaoAliquotaIbsUf = dtoIbsCbs.percentualReducaoAliquotaIbsUf;
                  impostoItemIbsCbs.aliquotaEfetivaIbsUf = dtoIbsCbs.aliquotaEfetivaIbsUf;
                  impostoItemIbsCbs.valorIbsUf = dtoIbsCbs.valorIbsUf;
                  impostoItemIbsCbs.valorDiferimentoIbsUf = dtoIbsCbs.valorDiferimentoIbsUf;
                  impostoItemIbsCbs.valorDevolucaoTributoIbsUf = dtoIbsCbs.valorDevolucaoTributoIbsUf;
                  impostoItemIbsCbs.aliquotaIbsMunicipio = dtoIbsCbs.aliquotaIbsMunicipio;
                  impostoItemIbsCbs.percentualReducaoAliquotaIbsMunicipio = dtoIbsCbs.percentualReducaoAliquotaIbsMunicipio;
                  impostoItemIbsCbs.aliquotaEfetivaIbsMunicipio = dtoIbsCbs.aliquotaEfetivaIbsMunicipio;
                  impostoItemIbsCbs.valorIbsMunicipio = dtoIbsCbs.valorIbsMunicipio;
                  impostoItemIbsCbs.valorDiferimentoIbsMunicipio = dtoIbsCbs.valorDiferimentoIbsMunicipio;
                  impostoItemIbsCbs.valorDevolucaoTributoIbsMunicipio = dtoIbsCbs.valorDevolucaoTributoIbsMunicipio;
                  impostoItemIbsCbs.aliquotaCbs = dtoIbsCbs.aliquotaCbs;
                  impostoItemIbsCbs.percentualReducaoAliquotaCbs = dtoIbsCbs.percentualReducaoAliquotaCbs;
                  impostoItemIbsCbs.aliquotaEfetivaCbs = dtoIbsCbs.aliquotaEfetivaCbs;
                  impostoItemIbsCbs.valorCbs = dtoIbsCbs.valorCbs;
                  impostoItemIbsCbs.valorDiferimentoCbs = dtoIbsCbs.valorDiferimentoCbs;
                  impostoItemIbsCbs.valorDevolucaoTributoCbs = dtoIbsCbs.valorDevolucaoTributoCbs;
                  impostoItemIbsCbs.valorIbsTotal = dtoIbsCbs.valorIbsTotal;

                  state.venda.notaFiscal.totalImpostos.valorIbsUfTotal += dtoIbsCbs.valorIbsUf ?? 0;
                  state.venda.notaFiscal.totalImpostos.valorIbsMunicipioTotal += dtoIbsCbs.valorIbsMunicipio ?? 0;
                  state.venda.notaFiscal.totalImpostos.valorCbsTotal += dtoIbsCbs.valorCbs ?? 0;
                  state.venda.notaFiscal.totalImpostos.valorIbsTotal += dtoIbsCbs.valorIbsTotal ?? 0;
                  state.venda.notaFiscal.totalImpostos.valorBaseCalculoCbsTotal += dtoIbsCbs.valorBaseCalculoIbsCbs ?? 0;
                  state.venda.notaFiscal.totalImpostos.valorBaseCalculoIbsTotal += dtoIbsCbs.valorBaseCalculoIbsCbs ?? 0;
                }

                const dtoIbsCbsMonofasico = retornoCalculoTributacoes.ibsCbsMonofasico;
                if (dtoIbsCbsMonofasico) {
                  if (!state.venda.itens[index].itemNotaFiscal.impostos.ibsCbsMonofasico) {
                    state.venda.itens[index].itemNotaFiscal.impostos.ibsCbsMonofasico = {} as INotaFiscalItemImpostoIbsCbsMonofasico;
                  }
                  const impostoItem = state.venda.itens[index].itemNotaFiscal.impostos.ibsCbsMonofasico;

                  impostoItem.quantidadeBaseCalculoMonofasico = dtoIbsCbsMonofasico.quantidadeBaseCalculoMonofasico;
                  impostoItem.aliquotaAdRemIbs = dtoIbsCbsMonofasico.aliquotaAdRemIbs;
                  impostoItem.aliquotaAdRemCbs = dtoIbsCbsMonofasico.aliquotaAdRemCbs;
                  impostoItem.valorIbsMonofasico = dtoIbsCbsMonofasico.valorIbsMonofasico;
                  impostoItem.valorCbsMonofasico = dtoIbsCbsMonofasico.valorCbsMonofasico;
                  impostoItem.valorIbsMonofasicoRetencao = dtoIbsCbsMonofasico.valorIbsMonofasicoRetencao;
                  impostoItem.valorCbsMonofasicoRetencao = dtoIbsCbsMonofasico.valorCbsMonofasicoRetencao;
                  impostoItem.valorIbsMonofasicoDiferido = dtoIbsCbsMonofasico.valorIbsMonofasicoDiferido;
                  impostoItem.valorCbsMonofasicoDiferido = dtoIbsCbsMonofasico.valorCbsMonofasicoDiferido;
                  impostoItem.valorTotalIbsMonofasicoItem = dtoIbsCbsMonofasico.valorTotalIbsMonofasicoItem;
                  impostoItem.valorTotalCbsMonofasicoItem = dtoIbsCbsMonofasico.valorTotalCbsMonofasicoItem;
                }

                const dtoIbsCbsCreditoAjuste = retornoCalculoTributacoes.ibsCbsCreditoAjuste;
                if (dtoIbsCbsCreditoAjuste) {
                  if (!state.venda.itens[index].itemNotaFiscal.impostos.ibsCbsCreditoAjuste) {
                    state.venda.itens[index].itemNotaFiscal.impostos.ibsCbsCreditoAjuste = {} as INotaFiscalItemImpostoIbsCbsCreditoAjuste;
                  }
                  const impostoItem = state.venda.itens[index].itemNotaFiscal.impostos.ibsCbsCreditoAjuste;

                  impostoItem.competenciaApuracao = dtoIbsCbsCreditoAjuste.competenciaApuracao;
                  impostoItem.valorIbsAjuste = dtoIbsCbsCreditoAjuste.valorIbsAjuste;
                  impostoItem.valorCbsAjuste = dtoIbsCbsCreditoAjuste.valorCbsAjuste;
                  impostoItem.codigoClassificacaoCreditoPresumido = dtoIbsCbsCreditoAjuste.codigoClassificacaoCreditoPresumido;
                  impostoItem.valorBaseCalculoCreditoPresumido = dtoIbsCbsCreditoAjuste.valorBaseCalculoCreditoPresumido;
                  impostoItem.valorCreditoPresumidoIbs = dtoIbsCbsCreditoAjuste.valorCreditoPresumidoIbs;
                  impostoItem.valorCreditoPresumidoCbs = dtoIbsCbsCreditoAjuste.valorCreditoPresumidoCbs;
                  impostoItem.valorCreditoPresumidoCondicaoSuspensivaIbs = dtoIbsCbsCreditoAjuste.valorCreditoPresumidoCondicaoSuspensivaIbs;
                  impostoItem.tipoCreditoPresumidoIbsZfm = dtoIbsCbsCreditoAjuste.tipoCreditoPresumidoIbsZfm;
                  impostoItem.valorCreditoPresumidoIbsZfm = dtoIbsCbsCreditoAjuste.valorCreditoPresumidoIbsZfm;
                }
                state.venda.itens[index].itemNotaFiscal.impostos.valorTotalTributos = retornoCalculoTributacoes.valorTotalTributos;
                state.venda.notaFiscal.totalImpostos.valorAproximadoTributosTotal += state.venda.itens[index].itemNotaFiscal.impostos.valorTotalTributos;

                state.valorTotalImpostos = state.venda.notaFiscal.totalImpostos.valorIcmsTotal + state.venda.notaFiscal.totalImpostos.valorIcmsSubstituicaoTotal + state.venda.notaFiscal.totalImpostos.valorPisTotal + state.venda.notaFiscal.totalImpostos.valorCofinsTotal;
              }
            }
          }

          state.venda.notaFiscal.totalNotaFiscal = state.venda.notaFiscal.totalProdutos;
          const incidenciaTotal = state.incidenciasCalculo.filter((c) => c.incidencia === 'TotalNota');
          incidenciaTotal.forEach((itemIncidencia) => {
            if (itemIncidencia.identificador === 'IPI' && itemIncidencia.valor) {
              state.venda.notaFiscal.totalNotaFiscal += state.venda.notaFiscal.totalImpostos.valorIpiTotal;
            }
            if (itemIncidencia.identificador === 'Frete' && itemIncidencia.valor) {
              state.venda.notaFiscal.totalNotaFiscal += state.venda.notaFiscal.totalFrete;
            }
            if (itemIncidencia.identificador === 'Seguro' && itemIncidencia.valor) {
              state.venda.notaFiscal.totalNotaFiscal += state.venda.notaFiscal.totalSeguro;
            }
            if (itemIncidencia.identificador === 'OutrasDespesas' && itemIncidencia.valor) {
              state.venda.notaFiscal.totalNotaFiscal += state.venda.notaFiscal.totalOutrasDespesas;
            }
            if (itemIncidencia.identificador === 'Desconto' && itemIncidencia.valor) {
              state.venda.notaFiscal.totalNotaFiscal -= state.venda.notaFiscal.totalDesconto;
            }
          });

          state.venda.notaFiscal.percentualDesconto = UtilitarioMatematico.calcularPorcentagem(state.venda.notaFiscal.totalProdutos, state.venda.notaFiscal.totalDesconto);
          state.venda.totalServicos = 0;
          state.servicos.forEach((i) => {
            state.venda.totalServicos += i.valorTotal;
          });
          if (state.venda.itens.length > 0) {
            console.log('atualizarValoresTotais inicio', state.venda.itens[0].itemNotaFiscal.impostos.st.margemValorAdicionado, state.venda.itens[0].itemNotaFiscal.impostos.st.cest);
          }
          salvarCacheRegistro();
        }, 600);
      }
    }

    async function aplicarDescontoGlobal(tipo: 'VALOR' | 'PORCENTAGEM') {
      const totalProdutos = state.venda.notaFiscal.totalProdutos;
      if (totalProdutos <= 0) return;

      let valorDescontoAlvo = 0;
      if (tipo === 'PORCENTAGEM') {
        const valorCalculado = (totalProdutos * state.venda.notaFiscal.percentualDesconto) / 100;
        valorDescontoAlvo = servicoCalculosComerciais.formatarValor2CasasDecimais(valorCalculado);
        state.venda.notaFiscal.totalDesconto = valorDescontoAlvo;
      } else {
        valorDescontoAlvo = servicoCalculosComerciais.formatarValor2CasasDecimais(state.venda.notaFiscal.totalDesconto);

        const percentualCalculado = (valorDescontoAlvo / totalProdutos) * 100;
        state.venda.notaFiscal.percentualDesconto = percentualCalculado;
        state.venda.notaFiscal.totalDesconto = valorDescontoAlvo;
      }

      let somaDescontosAplicados = 0;
      let indexMaiorItem = 0;
      let maiorValorItem = 0;

      for (let i = 0; i < state.venda.itens.length; i += 1) {
        const itemNF = state.venda.itens[i].itemNotaFiscal;
        const subtotalItem = itemNF.quantidade * itemNF.precoUnitario;

        if (subtotalItem > maiorValorItem) {
          maiorValorItem = subtotalItem;
          indexMaiorItem = i;
        }

        let descontoItem = servicoCalculosComerciais.formatarValor2CasasDecimais(
          (subtotalItem / totalProdutos) * valorDescontoAlvo,
        );

        if (descontoItem > subtotalItem) descontoItem = subtotalItem;

        itemNF.valorDesconto = descontoItem;
        somaDescontosAplicados += descontoItem;
      }
      const diferenca = servicoCalculosComerciais.formatarValor2CasasDecimais(valorDescontoAlvo - somaDescontosAplicados);

      if (diferenca !== 0) {
        const itemAlvo = state.venda.itens[indexMaiorItem].itemNotaFiscal;
        const novoValor = itemAlvo.valorDesconto + diferenca;

        itemAlvo.valorDesconto = servicoCalculosComerciais.formatarValor2CasasDecimais(novoValor < 0 ? 0 : novoValor);
      }

      atualizarValoresTotais();
    }

    async function obterRegimeTributario() {
      const dadosEmpresa = await servicoEmpresas.obter(state.venda.codigoEmpresa);
      state.regimeTributario = dadosEmpresa.regimeTributario;
      state.regimeTributarioEspecial = dadosEmpresa.regimeTributarioEspecial;
    }

    async function atualizarDescontoGeral() {
      for (let index = 0; index < state.venda.itens.length; index += 1) {
        if (UtilitarioGeral.validaCodigo(state.venda.itens[index].itemNotaFiscal.codigoProdutoDefinicao)) {
          const subTotalProduto = servicoCalculosComerciais.formatarValor2CasasDecimais((state.venda.itens[index].itemNotaFiscal.quantidade * state.venda.itens[index].itemNotaFiscal.precoUnitario));

          if (state.venda.notaFiscal.totalDesconto > 0) {
            state.venda.itens[index].itemNotaFiscal.valorDesconto = servicoCalculosComerciais.calculaValorRateio(subTotalProduto, state.venda.notaFiscal.totalProdutos, state.venda.notaFiscal.totalDesconto);
          } else {
            state.venda.itens[index].itemNotaFiscal.valorDesconto = 0;
          }
        }
      }
    }

    function adicionarTaxasPagamento(acrescimo: number, outrasTaxas: number) {
      state.venda.notaFiscal.totalOutrasDespesas += outrasTaxas;
      if (acrescimo > 0) {
        state.venda.itens.forEach((i, index) => {
          state.venda.itens[index].itemNotaFiscal.precoUnitario = state.venda.itens[index].precoTabela;
          const subTotalProduto = servicoCalculosComerciais.formatarValor2CasasDecimais((state.venda.itens[index].itemNotaFiscal.quantidade * state.venda.itens[index].itemNotaFiscal.precoUnitario));
          const acrescimoItem = servicoCalculosComerciais.calculaValorRateio(subTotalProduto, state.venda.notaFiscal.totalProdutos, acrescimo);
          state.venda.itens[index].itemNotaFiscal.precoUnitario += (acrescimoItem / state.venda.itens[index].itemNotaFiscal.quantidade);
        });
        atualizarValoresTotais();
      }
    }

    function removerTaxasPagamento(acrescimo: number, outrasTaxas: number) {
      state.venda.notaFiscal.totalOutrasDespesas -= outrasTaxas;
      state.venda.itens.forEach((i, index) => {
        const subTotalProduto = servicoCalculosComerciais.formatarValor2CasasDecimais((state.venda.itens[index].itemNotaFiscal.quantidade * state.venda.itens[index].itemNotaFiscal.precoUnitario));
        if (acrescimo > 0) {
          const acrescimoItem = servicoCalculosComerciais.calculaValorRateio(subTotalProduto, state.venda.notaFiscal.totalProdutos, acrescimo);
          state.venda.itens[index].itemNotaFiscal.precoUnitario -= (acrescimoItem / state.venda.itens[index].itemNotaFiscal.quantidade);
        }
      });
      atualizarValoresTotais();
    }

    async function atualizarInformacoesPessoa() {
      const dados = await servicoPessoa.obterDadosMovimentacao(state.venda.notaFiscal.destinatario.codigoPessoa, state.venda.codigoEmpresa);
      state.statusBloqueioCliente = await servicoCliente.obterStatusBloqueioCliente(state.venda.codigoCliente, ETipoBloqueioCliente.Movimentacao, 0);
      state.tipoInfoBloqueioCliente = state.liberacaoBloqueioCliente ? 'info' : 'warning';
      if (dados.cpfCnpj !== state.dadosPessoaMovimento.cpfCnpj && UtilitarioGeral.validaLista(state.venda.notaFiscal.detalhesPagamento) && state.dadosPessoaMovimento.cpfCnpj !== '') {
        apresentarMensagemAlerta('Detalhes de pagamentos zerados devido a alteração do cliente!');
        state.venda.notaFiscal.detalhesPagamento = [] as INotaFiscalDetalhePagamento[];
      }
      if (!state.tipoFreteManual && dados.tipoFrete !== ETipoFrete.SemOcorrenciaTransporte) {
        state.venda.notaFiscal.tipoFrete = dados.tipoFrete;
      }
      state.dadosPessoaMovimento = dados;
      state.buscarDadosFiscaisRecalcular = true;
      state.criacaoVendaAutomatico = servicoVendas.estrategiaCriacaoVendaAutomatico(state.venda);
      verificarPermissaoNFeNFce();
    }

    async function atualizarInformacoesColaborador() {
      await salvarCacheRegistro();
      state.criacaoVendaAutomatico = servicoVendas.estrategiaCriacaoVendaAutomatico(state.venda);
    }

    async function recuperarCacheRegistro() {
      if (UtilitarioGeral.valorValido(state.cacheRegistro.dados)) {
        telaBase.carregando = true;
        const vendaCache = JSON.parse(state.cacheRegistro.dados);
        if (UtilitarioGeral.objetoValido(vendaCache)) {
          state.venda = vendaCache;
          state.cacheDisponivel = false;
          state.cacheRegistro = {} as ISalvamentoAutomatico;
          state.cacheRegistro.codigo = 0;
          apresentarMensagemSucesso('Informações recuperadas com sucesso!');
        }
        telaBase.carregando = false;
      }
    }

    async function excluirCacheRegistro() {
      servicoSistema.removerSalvamentoAutomaticoApi(dadosEmpresa.value.codigoEmpresa, storeSistema.getters.codigoUsuarioAutenticado(), obterIdentificadorCache());
      servicoSistema.removerSalvamentoAutomaticoLocalStorage(`${obterIdentificadorCache()}_${storeSistema.getters.codigoUsuarioAutenticado()}`);
    }

    async function obterCacheRegistro() {
      let dataAlteracao = UtilitarioData.obterDataAtual();
      if (props.codigoVenda > 0 && props.codigoVenda !== undefined) {
        dataAlteracao = state.venda.dataAlteracao;
      }

      const cacheApi = await servicoSistema.obterUltimoSalvamentoAutomaticoApi(dadosEmpresa.value.codigoEmpresa, storeSistema.getters.codigoUsuarioAutenticado(), obterIdentificadorCache());
      const cacheLocalStorage = await servicoSistema.obterSalvamentoAutomaticoLocalStorage(`${obterIdentificadorCache()}_${storeSistema.getters.codigoUsuarioAutenticado()}`);
      state.cacheRegistro = servicoSistema.obterSalvamentoMaisRecente(cacheApi, cacheLocalStorage);

      if (UtilitarioData.validaDataPreenchida(state.cacheRegistro.data) && (props.codigoVenda === 0 || props.codigoVenda === undefined)) {
        state.cacheDisponivel = true;
        excluirCacheRegistro();
      } else if (UtilitarioData.validaDataPreenchida(state.cacheRegistro.data) && UtilitarioData.verificaDataMaisRecente(state.cacheRegistro.data, dataAlteracao)) {
        const vendaCache = JSON.parse(state.cacheRegistro.dados);
        if (vendaCache !== state.venda) {
          state.cacheDisponivel = true;
          excluirCacheRegistro();
        }
      }
    }

    async function obterFormaPagamento() {
      if (UtilitarioGeral.validaCodigo(state.venda.codigoFormaPagamento)) {
        if (state.venda.notaFiscal.detalhesPagamento.length > 0 && UtilitarioGeral.objetoValido(state.venda.formaPagamento)) {
          apresentarMensagemAlerta('Detalhes de pagamentos zerados devido a alteração da forma de pagamento!');
          state.venda.notaFiscal.detalhesPagamento = [] as INotaFiscalDetalhePagamento[];
        }
        state.venda.formaPagamento = await servicoFormaPagamento.obter(state.venda.codigoFormaPagamento);
        state.venda.formaPagamento.tiposDocumentosFinanceiro = await servicoFormaPagamento.obterTiposDocumentos(state.venda.codigoFormaPagamento, state.venda.codigoEmpresa);
        state.venda.formaPagamento.tabelasPreco = await servicoFormaPagamento.obterTabelasPreco(state.venda.codigoFormaPagamento, state.venda.codigoEmpresa);
        state.venda.formaPagamento.tabelasPreco.forEach((t) => {
          state.tabelasPrecosDisponiveis.push(t.codigoTabelaPreco);
        });
        salvarCacheRegistro();
      } else {
        state.venda.formaPagamento = {} as IFormaPagamento;
      }
      state.criacaoVendaAutomatico = servicoVendas.estrategiaCriacaoVendaAutomatico(state.venda);
    }

    async function obterMarcadores() {
      state.venda.notaFiscal.marcadores.forEach((m) => {
        state.marcadores.push(m.marcador);
      });
    }

    function preencherMarcadores() {
      const marcadores = [] as INotaFiscalMarcador[];

      state.marcadores.forEach((m) => {
        const marcador = {} as INotaFiscalMarcador;
        marcador.codigoNotaFiscal = state.venda.notaFiscal.codigo;
        marcador.marcador = m;
        marcador.ordem = marcadores.length + 1;
        marcadores.push(marcador);
      });
      return marcadores;
    }

    async function buscarItens() {
      const itens = await servicoVendas.obterItens(state.venda.codigo);
      state.venda.itens = itens;
    }

    async function buscarItensDadosAtualizados(atualizarValores: boolean) {
      state.venda.atualizarValores = atualizarValores;
      await buscarItens();
    }

    async function obterItens() {
      state.carregandoItens = true;
      await buscarItens();
      state.carregandoItens = false;
    }

    async function obterServicos() {
      const servicos = await servicoVendas.obterServicos(state.venda.codigo);
      state.venda.totalServicos = 0;
      state.venda.servicos = servicos;
      state.servicos = [] as INotaFiscalServicoItem[];
      servicos.forEach((s) => {
        state.servicos.push(s.notaFiscalServico.servicos[0]);
        state.venda.totalServicos += s.notaFiscalServico.totalNotaFiscal;
      });
    }

    async function preencherTipoOperacao(alterarCampos: boolean) {
      if (alterarCampos && (UtilitarioGeral.validaLista(state.venda.itens) || UtilitarioGeral.validaLista(state.servicos)) && !state.permitirAlterarTipoOperacao) {
        apresentarMensagemAlerta('Você não tem permissão para alterar o Tipo de Operação quando existem itens na venda.');
        state.venda.codigoTipoOperacao = state.tipoOperacao.codigo;
        return;
      }

      const codigoTipoOperacaoAnterior = state.tipoOperacao.codigo;

      const executarPreenchimento = async () => {
        if (state.venda.codigoTipoOperacao > 0) {
          state.tipoOperacao = await servicoTipoOperacao.obter(state.venda.codigoTipoOperacao, state.venda.codigoEmpresa);
          if (alterarCampos && props.editavel) {
            state.venda.codigoFormaPagamento = state.tipoOperacao.codigoFormaPagamento;
            state.buscarDadosFiscaisRecalcular = true;
            if (!state.tipoFreteManual && state.tipoOperacao.tipoFrete !== ETipoFrete.SemOcorrenciaTransporte && state.venda.notaFiscal.tipoFrete === ETipoFrete.SemOcorrenciaTransporte) {
              state.venda.notaFiscal.tipoFrete = state.tipoOperacao.tipoFrete;
            }
            state.venda.itens.forEach((item, index) => {
              state.venda.itens[index].itemNotaFiscal.movimentarEstoque = state.tipoOperacao.movimentarEstoque;
            });
          }
        } else {
          state.tipoOperacao = {} as ITipoOperacao;
          state.tipoOperacao.codigoFormaPagamento = 0;
          state.tipoOperacao.codigoCenarioFiscal = 0;
          state.tipoOperacao.movimentarEstoque = false;
        }
      };

      if (alterarCampos && (UtilitarioGeral.validaLista(state.venda.itens) || UtilitarioGeral.validaLista(state.servicos))) {
        Modal.confirm({
          title: 'Confirmar Alteração',
          content: 'A alteração do tipo de operação pode impactar os cálculos e regras da venda. Deseja continuar?',
          okText: 'Sim',
          cancelText: 'Não',
          onOk: async () => {
            await executarPreenchimento();
          },
          onCancel: () => {
            state.venda.codigoTipoOperacao = codigoTipoOperacaoAnterior;
          },
        });
      } else { await executarPreenchimento(); }
    }

    async function obterVenda(codigo: number, buscarItens = true) {
      state.criacaoVendaAutomatico = false;
      telaBase.carregando = true;

      state.venda = await servicoVendas.obter(codigo);
      state.venda.comissoes = await servicoVendas.obterComissoes(state.venda.codigo);
      state.venda.notaFiscal.percentualDesconto = UtilitarioMatematico.calcularPorcentagem(state.venda.notaFiscal.totalProdutos, state.venda.notaFiscal.totalDesconto);
      state.totalCaixaLancado = 0;
      state.totalCarteiraLancado = 0;
      state.totalOutrosLancado = 0;
      state.venda.notaFiscal.detalhesPagamento.forEach((d) => {
        if (d.gerarCaixa) {
          state.totalCaixaLancado += d.valorTotal;
        } else if (d.gerarCarteira) {
          state.totalCarteiraLancado += d.valorTotal;
        } else {
          state.totalOutrosLancado += d.valorTotal;
        }
      });
      await atualizarInformacoesPessoa();
      state.venda.atualizarValores = false;
      state.venda.itens = [] as IVendaItem[];
      if (UtilitarioGeral.validaLista(state.venda.notaFiscal.incidenciasCalculo)) {
        state.incidenciasCalculo = state.venda.notaFiscal.incidenciasCalculo;
      }
      telaBase.carregando = false;
      obterMarcadores();
      obterFormaPagamento();
      if (buscarItens) {
        await obterItens();
        await obterServicos();
        await atualizarValoresTotais();
      }
      await preencherTipoOperacao(false);
      state.valorTotalImpostos = state.venda.notaFiscal.totalImpostos.valorIcmsTotal + state.venda.notaFiscal.totalImpostos.valorIcmsSubstituicaoTotal + state.venda.notaFiscal.totalImpostos.valorPisTotal + state.venda.notaFiscal.totalImpostos.valorCofinsTotal;
      state.venda.notaFiscal.percentualDesconto = UtilitarioMatematico.calcularPorcentagem(state.venda.notaFiscal.totalProdutos, state.venda.notaFiscal.totalDesconto);

      state.registrosAtividade = await servicoNotaFiscal.obterRegistrosAtividade(state.venda.notaFiscal.codigo);
      state.editavel = props.editavel;
      if (state.editavel && !UtilitarioGeral.validaLista(state.venda.itens)) {
        state.adicionarPrimeiroItem = true;
      }
    }

    function validarCampos() {
      if (!UtilitarioGeral.validaCodigo(state.venda.codigoVendedor)) {
        apresentarMensagemAlerta('O vendedor deve ser informado!');
        return false;
      }

      if (!UtilitarioGeral.validaCodigo(state.venda.codigoCliente)) {
        apresentarMensagemAlerta('O cliente deve ser informado!');
        return false;
      }

      if (!UtilitarioGeral.validaCodigo(state.venda.codigoFormaPagamento)) {
        apresentarMensagemAlerta('A forma de pagamento deve ser informado!');
        return false;
      }

      if (state.statusBloqueioCliente && !state.liberacaoBloqueioCliente) {
        requisicaoAutorizacaoBase.permissao = 'AUT_VENDA_BLOQUEIO_MOV';
        requisicaoAutorizacaoBase.descricao = 'Autorização para Cliente com bloqueio de movimentação!';
        requisicaoAutorizacaoBase.exibirRequisicao = true;
        return false;
      }

      return true;
    }

    function excluirServico(codigo: number) {
      const index = state.venda.servicos.findIndex((s) => s.notaFiscalServico.servicos[0].codigo === codigo);
      state.venda.servicos.splice(index, 1);
    }

    async function montarNotasFiscaisServico() {
      if (!UtilitarioGeral.validaLista(state.venda.servicos)) state.venda.servicos = [] as IVendaNotaFiscalServico[];

      state.servicos.forEach((s) => {
        if (s.codigoNotaFiscalServico > 0) {
          const indexNota = state.venda.servicos.findIndex((nfs) => nfs.codigoNotaFiscalServico === s.codigoNotaFiscalServico);
          state.venda.servicos[indexNota].notaFiscalServico.servicos[0] = s;
          state.venda.servicos[indexNota].notaFiscalServico.prestador.regimeTributario = state.regimeTributario;
          state.venda.servicos[indexNota].notaFiscalServico.prestador.regimeTributarioEspecial = state.regimeTributarioEspecial;
        } else {
          const notaFiscalServico = servicoServico.instanciarNotaFiscalServico(state.venda.codigoEmpresa, storeSistema.getters.codigoUsuarioAutenticado());
          const vendaNfse = {} as IVendaNotaFiscalServico;
          notaFiscalServico.servicos.push(s);
          notaFiscalServico.totalImpostos.totalBaseCalculo += s.impostos.baseCalculo;
          notaFiscalServico.totalImpostos.totalIss += s.impostos.valorIss;
          notaFiscalServico.totalImpostos.totalIssRetido += s.impostos.valorIssRetido;
          notaFiscalServico.totalImpostos.totalPis += s.impostos.valorPis;
          notaFiscalServico.totalImpostos.totalCofins += s.impostos.valorCofins;
          notaFiscalServico.totalImpostos.totalIr += s.impostos.valorIr;
          notaFiscalServico.totalImpostos.totalInss += s.impostos.valorInss;
          notaFiscalServico.totalImpostos.totalCsll += s.impostos.valorCsll;
          notaFiscalServico.totalImpostos.totalValorAproximadoTributos += s.impostos.valorAproximadoTributos;
          notaFiscalServico.totalServicos = s.valorTotal;
          notaFiscalServico.totalNotaFiscal = s.valorTotal;
          vendaNfse.notaFiscalServico = notaFiscalServico;
          vendaNfse.codigoVenda = state.venda.codigo;
          vendaNfse.notaFiscalServico.prestador.regimeTributario = state.regimeTributario;
          vendaNfse.notaFiscalServico.prestador.regimeTributarioEspecial = state.regimeTributarioEspecial;
          state.venda.servicos.push(vendaNfse);
        }
      });
    }

    async function salvar() {
      let retorno: IRetornoRequisicao = { codigoRegistro: 0, status: 0, mensagem: '' };
      if (!validarCampos()) return;
      try {
        state.criacaoVendaAutomatico = false;
        if (state.venda.codigo > 0) await montarNotasFiscaisServico();

        if (!UtilitarioGeral.validaCodigo(state.venda.codigoTipoOperacao)) {
          apresentarMensagemAlerta('O tipo de operação deve ser informado!');
          return;
        }

        state.venda.notaFiscal.detalhesPagamento.forEach((d) => {
          if (!UtilitarioGeral.validaCodigo(d.codigoPlanoContaCategoria) && retorno.status !== EStatusRetornoRequisicao.Erro) {
            retorno.status = EStatusRetornoRequisicao.Erro;
            apresentarMensagemAlerta('Todos os detalhes de pagamento devem ter categoria definida!');
          }
        });
        if (retorno.status === EStatusRetornoRequisicao.Erro) {
          return;
        }

        const retornoValidacaoPagamento = await servicoVendas.validarFormaPagamento(state.venda.notaFiscal, state.venda.formaPagamento);
        if (retornoValidacaoPagamento.status !== EStatusRetornoRequisicao.Sucesso) {
          apresentarRetornoRequisicao(retornoValidacaoPagamento);
          return;
        }

        state.venda.notaFiscal.marcadores = preencherMarcadores();
        state.venda.notaFiscal.incidenciasCalculo = state.incidenciasCalculo;
        state.venda.notaFiscal.detalhesPagamento.forEach((d, indexD) => {
          state.venda.notaFiscal.detalhesPagamento[indexD].codigoNotaFiscal = state.venda.notaFiscal.codigo;
        });

        if (UtilitarioGeral.validaLista(state.venda.itens)) {
          const indexSemCodigos: number[] = [];
          for (let index = 0; index < state.venda.itens.length; index += 1) {
            if (!UtilitarioGeral.validaCodigo(state.venda.itens[index].itemNotaFiscal.codigoProdutoDefinicao)) {
              indexSemCodigos.push(index);
            }
          }
          indexSemCodigos.forEach((index) => {
            state.venda.itens.splice(index, 1);
          });

          state.venda.notaFiscal.naturezaOperacao = UtilitarioGeral.limitarQuantidadeMaximaCaracteres(state.tipoOperacao.descricao, 60);
        }

        if (state.venda.notaFiscal.totalImpostos.valorAproximadoTributosTotal > 0) {
          if (UtilitarioGeral.objetoValido(state.venda.notaFiscal.dadosAdicionais)) {
            if (!state.venda.notaFiscal.dadosAdicionais.includes('VALOR APROX. TRIBUTOS R$')) {
              const percentual = UtilitarioMatematico.valorDecimal2Casas((state.venda.notaFiscal.totalImpostos.valorAproximadoTributosTotal / state.venda.notaFiscal.totalNotaFiscal) * 100);
              state.venda.notaFiscal.dadosAdicionais += `VALOR APROX. TRIBUTOS R$ ${UtilitarioMascara.mascararValor(state.venda.notaFiscal.totalImpostos.valorAproximadoTributosTotal)} (${percentual} %) Fonte: IBPT`;
            }
          }
        }

        await calcularComissoes();

        if (state.venda.codigo > 0 && state.venda.codigo !== undefined) {
          apresentarBarraProgresso('Aguarde por favor...');
          retorno = await servicoVendas.alterar(state.venda);
        } else if (state.venda.codigo === 0 && props.duplicarVenda) {
          state.venda.notaFiscal.status = EStatusNotaFiscal.Pendente;
          retorno = await servicoVendas.incluirVendaDuplicada(state.venda);
          computedDuplicarVenda.value = false;
          emit('update:duplicar', false);
        } else {
          state.incluindoCabecalhoVenda = true;
          retorno = await servicoVendas.incluirCabecalho(state.venda);
        }
        if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
          excluirCacheRegistro();
          if (state.venda.codigo === 0) {
            state.venda.codigo = retorno.codigoRegistro;
            if (state.incluindoCabecalhoVenda) {
              await obterVenda(state.venda.codigo, false);
            } else {
              state.incluindoCabecalhoVenda = false;
              ocultarBarraProgresso();
              emit('confirmacao');
              apresentarMensagemSucesso(retorno.mensagem);
            }
          } else {
            state.incluindoCabecalhoVenda = false;
            emit('confirmacao');
            await obterVenda(state.venda.codigo, true);
            await obterRegimeTributario();
            ocultarBarraProgresso();
            apresentarMensagemSucesso(retorno.mensagem);
          }
        } else {
          state.incluindoCabecalhoVenda = false;
          apresentarRetornoRequisicao(retorno);
        }
      } catch (error) {
        ocultarBarraProgresso();
        state.incluindoCabecalhoVenda = false;
        const mensagem = error instanceof Error ? error.message : String(error);
        const retErro: IRetornoRequisicao = {
          codigoRegistro: 0,
          status: EStatusRetornoRequisicao.Erro,
          mensagem,
        };
        apresentarRetornoRequisicao(retErro);
      }
    }

    async function duplicarVenda() {
      await obterVenda(props.codigoVenda, true);
      state.venda.codigo = 0;
      state.venda.numero = 0;
      state.venda.status = EStatusVenda.EmDigitacao;
      const etapaVenda = processoVendas.value.etapas.find((e) => e.primeiraEtapa === true);
      if (etapaVenda !== undefined) {
        state.venda.codigoEtapaProcessoVendas = etapaVenda.codigo;
      } else {
        state.venda.codigoEtapaProcessoVendas = 0;
      }
      state.venda.comissoes.forEach((c) => {
        // eslint-disable-next-line no-param-reassign
        c.codigo = 0;
        // eslint-disable-next-line no-param-reassign
        c.codigoVenda = 0;
      });
      state.venda.registrosAtividades = [];
      state.venda.notaFiscal.naturezaOperacao = state.tipoOperacao.descricao;
      state.venda.codigoNotaFiscal = 0;
      state.venda.notaFiscal.codigo = 0;
      state.venda.notaFiscal.numeroNotaFiscal = 0;
      if (UtilitarioGeral.validaLista(state.venda.itens)) {
        state.venda.itens.forEach((i) => {
          // eslint-disable-next-line no-param-reassign
          i.codigo = 0;
          // eslint-disable-next-line no-param-reassign
          i.codigoVenda = 0;
          // eslint-disable-next-line no-param-reassign
          i.itemNotaFiscal.codigo = 0;
          // eslint-disable-next-line no-param-reassign
          i.itemNotaFiscal.codigoNotaFiscal = 0;
          // eslint-disable-next-line no-param-reassign
          i.codigoNotaFiscalItem = 0;
        });
      }
      state.venda.notaFiscal.detalhesPagamento.forEach((d) => {
        // eslint-disable-next-line no-param-reassign
        d.codigo = 0;
        // eslint-disable-next-line no-param-reassign
        d.codigoNotaFiscal = 0;
      });
      state.venda.notaFiscal.destinatario.codigoNotaFiscal = 0;
      state.venda.notaFiscal.destinatario.codigo = 0;
      state.venda.notaFiscal.emitente.codigoNotaFiscal = 0;
      state.venda.notaFiscal.emitente.codigo = 0;
      state.venda.notaFiscal.emitente.endereco.codigoNotaFiscalEmitente = 0;
      state.venda.notaFiscal.emitente.endereco.codigo = 0;
      state.venda.notaFiscal.incidenciasCalculo.forEach((i) => {
        // eslint-disable-next-line no-param-reassign
        i.codigo = 0;
        // eslint-disable-next-line no-param-reassign
        i.codigoNotaFiscal = 0;
      });
      state.venda.notaFiscal.itens.forEach((i) => {
        // eslint-disable-next-line no-param-reassign
        i.codigo = 0;
        // eslint-disable-next-line no-param-reassign
        i.codigoNotaFiscal = 0;
        // eslint-disable-next-line no-param-reassign
        i.rastreabilidades = [];
        // eslint-disable-next-line no-param-reassign
        i.medicamento.codigoNotaFiscalItem = 0;
        // eslint-disable-next-line no-param-reassign
        i.medicamento.codigo = 0;
        // eslint-disable-next-line no-param-reassign
        i.estoques = [];
      });
      state.venda.notaFiscal.marcadores.forEach((m) => {
        // eslint-disable-next-line no-param-reassign
        m.codigo = 0;
        // eslint-disable-next-line no-param-reassign
        m.codigoNotaFiscal = 0;
      });
      if (UtilitarioGeral.valorValido(state.venda.servicos)) {
        state.venda.servicos.forEach((s) => {
        // eslint-disable-next-line no-param-reassign
          s.notaFiscalServico.codigo = 0;
          s.notaFiscalServico.servicos.forEach((i) => {
            // eslint-disable-next-line no-param-reassign
            i.codigo = 0;
          });
        });
      }
      computedDuplicarVenda.value = false;
      emit('update:duplicar', false);
      await salvar();
      await obterVenda(state.venda.codigo, true);
      await obterRegimeTributario();
    }

    watch(async () => modalBase.computedVisivel, async () => {
      state.telaMobile = UtilitarioDispositivo.larguraTelaMobile();
      limparTela();
      if (modalBase.computedVisivel) {
        telaBase.carregando = true;
        await preencherEmpresasDisponiveis();
        telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas(telaBase.empresasSelecionadas);
        const autorizacaoBloqueioMov = await servicoSistema.obterPermissoesAutorizacoesUsuario('AUT_VENDA_BLOQUEIO_MOV');
        state.liberacaoBloqueioCliente = servicoSistema.verificaAutorizacao(state.venda.codigoEmpresa, 'AUT_VENDA_BLOQUEIO_MOV', autorizacaoBloqueioMov);
        const autorizacaoBloqueio = await servicoSistema.obterPermissoesAutorizacoesUsuario('AUT_ALTERACAO_COMISSAO');
        state.editarComissao = servicoSistema.verificaAutorizacao(state.venda.codigoEmpresa, 'AUT_ALTERACAO_COMISSAO', autorizacaoBloqueio);
        const autorizacaoAlterarTipoOperacao = await servicoSistema.obterPermissoesAutorizacoesUsuario('AUT_ALTERAR_TIPO_OPERACAO');
        state.permitirAlterarTipoOperacao = servicoSistema.verificaAutorizacao(state.venda.codigoEmpresa, 'AUT_ALTERAR_TIPO_OPERACAO', autorizacaoAlterarTipoOperacao);
        state.tipoInfoBloqueioCliente = state.liberacaoBloqueioCliente ? 'info' : 'warning';
        if (props.codigoVenda > 0 && computedDuplicarVenda.value) {
          await duplicarVenda();
        } else if (props.codigoVenda > 0 && props.codigoVenda !== undefined) {
          await obterVenda(props.codigoVenda);
          await obterRegimeTributario();
        }
        telaBase.carregando = false;
        obterCacheRegistro();
        clearTimeout(debounceRenderizar);
        debounceRenderizar = setTimeout(async () => {
          focusElemento(1);
        }, 150);
      }
    });

    watch(async () => state.criacaoVendaAutomatico, async () => {
      if (state.criacaoVendaAutomatico) {
        await salvar();
      }
    });

    watch(async () => state.abaAtiva, async () => {
      if (state.abaAtiva === '10') {
        calcularComissoes();
      }
    });

    async function concluirEtapa() {
      Modal.confirm({
        title: `Deseja concluir a etapa da venda: ${state.venda.numero}?`,
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        onOk: async () => {
          const retorno = await servicoVendas.concluirEtapa(state.venda.codigo);
          if (retorno.status !== 1) {
            apresentarMensagemAlerta(retorno.mensagem);
          } else {
            apresentarMensagemSucesso('Etapa concluída com sucesso!');
            emit('confirmacao');
          }
        },
      });
    }

    async function retornarEtapa() {
      Modal.confirm({
        title: `Deseja retornar a etapa anterior da venda: ${state.venda.numero}?`,
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        onOk: async () => {
          const retorno = await servicoVendas.retornarEtapa(state.venda.codigo);
          if (retorno.status !== 1) {
            apresentarMensagemAlerta(retorno.mensagem);
          } else {
            apresentarMensagemSucesso('Venda retornada com sucesso!');
            emit('confirmacao');
          }
        },
      });
    }

    function excluir() {
      Modal.confirm({
        title: 'Realmente deseja excluir a venda?',
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        onOk: async () => {
          const retorno = await servicoVendas.excluir(state.venda.codigo);
          if (retorno.status !== 1) {
            apresentarMensagemErro(retorno.mensagem);
          } else {
            apresentarMensagemSucesso('Venda excluída com sucesso!');
            emit('confirmacao');
            modalBase.computedVisivel = false;
          }
        },
      });
    }

    async function imprimir() {
      const retornoRelatorio = await servicoVendas.imprimirVenda(state.venda.codigo, ETipoArquivo.PDF);
      telaBase.carregando = false;
      if (retornoRelatorio.status === EStatusRetornoRequisicao.Sucesso) {
        state.arquivosPdf = [{ nome: '', link: retornoRelatorio.link } as IArquivoPdf];
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retornoRelatorio.mensagem);
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Erro) {
        apresentarMensagemErro(retornoRelatorio.mensagem);
      }
    }

    async function visualizarDFe() {
      if (UtilitarioGeral.valorValido(state.venda.codigo)) {
        const retorno = await servicoNotaFiscal.visualizar(state.venda.codigoNotaFiscal);
        if (retorno !== undefined) {
          if (retorno.sucesso) {
            if (UtilitarioGeral.valorValido(retorno.linkPdf)) {
              state.arquivosPdf = [{ nome: '', link: retorno.linkPdf } as IArquivoPdf];
            }
          } else if (UtilitarioGeral.valorValido(retorno.mensagem)) {
            apresentarMensagemAlerta(retorno.mensagem);
          }
        }
      }
    }

    function obtemDescricaoIncidencia(identificador: string): string {
      if (identificador === 'OutrasDespesas') {
        return 'Outras Despesas';
      }

      return identificador;
    }

    async function atualizarAnexo(index: number) {
      if (state.venda.codigo === undefined || state.venda.codigo === 0) return;

      if (state.venda.notaFiscal.anexos[index].codigo === undefined || state.venda.notaFiscal.anexos[index].codigo === 0) {
        state.venda.notaFiscal.anexos[index].codigoNotaFiscal = state.venda.notaFiscal.codigo;
      }
    }

    async function excluirAnexo(codigoAnexo: number) {
      if (state.venda.codigo === undefined || state.venda.codigo === 0) return;

      await servicoNotaFiscal.excluirAnexo(codigoAnexo, state.venda.codigoEmpresa);
    }

    async function verificaFocoFormaPagamento() {
      if (state.venda.codigo === 0) {
        await salvar();
      }
    }

    function copiarChave() {
      if (state.venda.notaFiscal.chaveAcesso) {
        navigator.clipboard
          .writeText(state.venda.notaFiscal.chaveAcesso);
      }
    }

    return {
      props,
      state,
      telaBase,
      modalBase,
      requisicaoAutorizacaoBase,
      etapa,
      ETipoValorMovimentacao,
      ETipoMovimentoComercial,
      ETipoRelacaoPessoa,
      servicoVendas,
      UtilitarioGeral,
      UtilitarioMascara,
      salvarCacheRegistro,
      storeSistema,
      recuperarCacheRegistro,
      apresentarRetornoRequisicao,
      atualizarDescontoGeral,
      atualizarValoresTotais,
      obterFormaPagamento,
      buscarItensDadosAtualizados,
      obterVenda,
      salvar,
      concluirEtapa,
      retornarEtapa,
      excluir,
      imprimir,
      obtemDescricaoIncidencia,
      atualizarAnexo,
      excluirAnexo,
      focusElemento,
      proximoElemento,
      elementoAnterior,
      verificaFocoFormaPagamento,
      atualizarInformacoesPessoa,
      atualizarInformacoesColaborador,
      adicionarTaxasPagamento,
      removerTaxasPagamento,
      excluirServico,
      permissaoServico,
      preencherTipoOperacao,
      ECustomRenderRow,
      EStatusNotaFiscal,
      visualizarDFe,
      copiarChave,
      computedDuplicarVenda,
      calcularComissoes,
      possuiOrdensProducaoVinculadas,
      EStatusVenda,
      aplicarDescontoGlobal,
    };
  },
});
